import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { ActorAuthChecklistService } from '../actor-auth.checklist/actor-auth.checklist.service';
import { IActorSplugDialogData } from '../actor-splug-info/actor-splug-info.component';
import { ActorSplugInfoService } from '../actor-splug-info/actor-splug-info.service';
import { ActorConfigService } from './actor-config.service';

@Component({
  selector: 'ss-actor-config',
  templateUrl: './actor-config.component.html',
  styleUrls: ['./actor-config.component.scss'],
  host: {
    class: 'full-stretch background-white padding-none'
  },
  providers: [
    ActorSplugInfoService,
    ActorAuthChecklistService,
    ActorConfigService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorConfigComponent {

  get actor() {
    return this._data.actor
  }

  readonly externalSubject = this._actorConfigService.externalSubject

  get actorDisplay() {
    return this.actor.firstName + ' ' + this.actor.lastName
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: IActorSplugDialogData,
    private readonly _actorConfigService: ActorConfigService,
    private readonly _matDialogRef: MatDialogRef<any, any>
  ) {

  }


  validateAndSave() {

    this._actorConfigService.validateAndSave();

  }

  validate() {
    this._actorConfigService.validate().pipe(take(1)).subscribe()
  }

  cancel() {
    this._data.actorSplugInfoDialogService.close();
  }
}
